exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-filter-select[data-v-b607fb24]{max-width:220px}.custom-filter-select[data-v-b607fb24]>:first-child>:first-child{margin:0!important}.custom-filter-select[data-v-b607fb24]>:first-child>:last-child{display:none!important}", ""]);

// exports
